module.exports = __webpack_public_path__ + "img/2.14.4bea519e.png";